import { useMutation, useQueryClient } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { newsletterThemeTemplateQueryKeys } from "./queryKeys";
import { NewsletterThemeTemplateUpdate, Section } from "../../models/newsletterThemeTemplate/NewsletterThemeTemplate";

export function useNewsletterThemeSectionMutations(themeId: string) {
  const queryClient = useQueryClient();
  const { put } = useApiHelper();
  const { saveHandlers } = useDefaultCRUDHandlers("Newsletter Template Section");

  const updateSection = useMutation(
    ({ section, data }: { section: Section; data: { subject: string; body: string } }) =>
      put(`/emailtemplate/newsletter/${themeId}/sections/${section}`, data),
    {
      ...saveHandlers,
      onSuccess: (_) => { 
        queryClient.invalidateQueries(
          newsletterThemeTemplateQueryKeys.byThemeId(themeId)
        );
        saveHandlers.onSuccess?.();
      },
    }
  );

  return {
    updateSection,
  };
}

